import { PLATFORM_DATE_FORMAT } from "../constants";
import { parseDateString } from "./parse-date-string";
export var isDatePast = function isDatePast(dateString, fromFormat) {
  if (fromFormat === void 0) {
    fromFormat = PLATFORM_DATE_FORMAT;
  }

  var date = parseDateString(dateString, fromFormat);
  var now = new Date();

  if (!date) {
    return false;
  }

  return date < now;
};